import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import autobind from "class-autobind"
import moment from "moment"
import * as timeHelper from "../../helpers/timeHelper"
import strings from "../../localization/strings"
import { blueGrey500 } from "material-ui/styles/colors"
import FinddDatePicker from "./FinddDatePicker"
interface IProps {
  title: string
  titleStyle: React.CSSProperties
  chipStyle: React.CSSProperties
  addButtonStyle: React.CSSProperties
  dates: Date[]
  error: string
  handleChange(dates: Date[]): void
  handleSnackbarAlertContent(snackbarAlertContent: string): void
}
interface IState {
  openCalendar: boolean
}

export default class DatesChip extends React.Component<IProps, IState> {
  private FinddDatePicker
  constructor(props: IProps) {
    super(props)
    this.state = {
      openCalendar: false,
    }
    autobind(this)
  }

  handleOpenDatePickerDialog() {
    this.FinddDatePicker.DatePicker.refs.dialogWindow.setState({ open: true })
  }

  handleDelete(date) {
    const dates = this.props.dates.slice().filter(item => item !== date)
    this.props.handleChange(dates)
  }

  handleAdd(date) {
    this.setState({ openCalendar: false })
    const utcDate = moment(date).utc(true).startOf("day").toDate()
    if (this.props.dates.find(item => moment(item).isSame(utcDate))) {
      this.props.handleSnackbarAlertContent(strings.This_date_exists_already)
    }
    else {
      const dates = this.props.dates.slice()
      dates.push(utcDate)
      this.props.handleChange(dates.sort((a, b) => moment(a).isBefore(b) ? -1 : 1))
    }
  }

  render() {
    return (
      <div style={{ position: "relative" }}>
        <span style={this.props.titleStyle}>{this.props.title}</span>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {this.props.dates.map((date, index) =>
            <Chip key={index} onRequestDelete={() => this.handleDelete(date)} style={this.props.chipStyle}>
              {moment(timeHelper.keepConvertUTCToLocal(date)).format("DD/MM/YYYY")}
            </Chip>
          )}
          <div style={this.props.addButtonStyle}>
            {!this.state.openCalendar &&
              <IconButton data-intercom-target={"Btn-OpenDatePicker"} onTouchTap={() => this.setState({ openCalendar: true }, () => this.handleOpenDatePickerDialog())}>
                <FontIcon className="fa fa-plus-circle" />
              </IconButton>
            }
          </div>
        </div>
        {this.props.error && !this.state.openCalendar &&
          <div style={{ position: "absolute", bottom: -20, fontSize: 12, color: "rgb(244, 67, 54)", transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms" }}>
            {this.props.error}
          </div>
        }
        <FinddDatePicker
          data-intercom-target={"Select-Date"}
          name="HideInputForDatePicker"
          style={{ display: "none" }}
          ref={item => this.FinddDatePicker = item}
          formatDate={date => moment(date).format("MM/DD/YYYY")}
          onChange={(e, date) => this.handleAdd(date)}
          cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
          onDismiss={() => this.setState({ openCalendar: false })}
          firstDayOfWeek={0}
        />
      </div>
    )
  }
}